import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=6e850784&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=js"
export * from "./FormPage.vue?vue&type=script&lang=js"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=6e850784&prod&lang=scss"
import style1 from "./FormPage.vue?vue&type=style&index=1&id=6e850784&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e850784",
  null
  
)

export default component.exports